<script>
    import {Nav, Container} from "svelte-chota";
    import Pages from "./Pages.svelte";

    export let keycloak;
</script>

<main>
    <Nav>
        <a slot="center" href="/" class="brand text-light"><img class="logo" src="/imgs/logo.svg" alt="logo"/> kkInc</a>
    </Nav>
    <Container>
        <Pages keycloak={keycloak}/>
    </Container>
</main>

<style>
    main {
        height: 100vh;
    }
</style>
